/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Detail_Load_Error_TitleInputs */

const en_case_detail_load_error_title = /** @type {(inputs: Case_Detail_Load_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not load case`)
};

const pt_br2_case_detail_load_error_title = /** @type {(inputs: Case_Detail_Load_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar o caso`)
};

/**
* | output |
* | --- |
* | "Could not load case" |
*
* @param {Case_Detail_Load_Error_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_detail_load_error_title = /** @type {((inputs?: Case_Detail_Load_Error_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Detail_Load_Error_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_detail_load_error_title(inputs)
	return pt_br2_case_detail_load_error_title(inputs)
});